import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { motion } from 'framer-motion';
import { ProtectedRoute } from './ProtectedRoute';
import { publicRoutes, protectedRoutes, managerRoutes, adminRoutes, notFoundRoute } from './config';

// Loading component
function LoadingFallback() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-black">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-2 border-black/10 dark:border-white/10"></div>
          <motion.div
            className="absolute inset-0 rounded-full border-2 border-black dark:border-white border-t-transparent"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
        </div>
        <p className="text-sm text-black/40 dark:text-white/40 font-medium">
          Carregando...
        </p>
      </div>
    </div>
  );
}

export function AppRoutes() {
  const NotFoundComponent = notFoundRoute.element;

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route) => {
          const Component = route.element;
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<Component />}
            />
          );
        })}

        {/* Protected Routes (require authentication) */}
        <Route element={<ProtectedRoute />}>
          {protectedRoutes.map((route) => {
            const Component = route.element;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={<Component />}
              />
            );
          })}
          {/* Redirect aliases */}
          <Route path="/team" element={<Navigate to="/teams" replace />} />
          <Route path="/team/*" element={<Navigate to="/teams" replace />} />
          <Route path="/project" element={<Navigate to="/projects" replace />} />
          <Route path="/task" element={<Navigate to="/tasks" replace />} />
          <Route path="/user" element={<Navigate to="/users" replace />} />
          <Route path="/report" element={<Navigate to="/reports" replace />} />
          <Route path="/setting" element={<Navigate to="/settings" replace />} />
        </Route>

        {/* Manager Routes (require admin or manager role) */}
        <Route element={<ProtectedRoute requiredRoles={['admin', 'manager']} />}>
          {managerRoutes.map((route) => {
            const Component = route.element;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={<Component />}
              />
            );
          })}
        </Route>

        {/* Admin Routes (require admin role) */}
        <Route element={<ProtectedRoute requiredRole="admin" />}>
          {adminRoutes.map((route) => {
            const Component = route.element;
            return (
              <Route
                key={route.path}
                path={route.path}
                element={<Component />}
              />
            );
          })}
        </Route>

        {/* 404 Not Found - Catch all routes */}
        <Route path="*" element={<NotFoundComponent />} />
      </Routes>
    </Suspense>
  );
}